import * as R from 'ramda';
import { AppState } from '../../../core/redux/appState';
import { Action } from 'redux';
import { ActionType } from '../../../core/redux/actionType';


/**
 * Hash map of actions that don't count as user activity in the app for the purposes of logout timing. Boolean value is
 * just to ensure something truthy is returned when looking up actions in the map.
 * Needs to be a hash map for high lookup performance, even if an array is more intuitive.
 */
const ACTIONS_TO_IGNORE: { [key: string]: true } = {
  [ActionType.LogOut]: true,

  // Polling Status Check doesn't count as user activity
  [ActionType.LoadCurrentStatusRequest]:  true,
  [ActionType.LoadCurrentStatusResponse]: true,
  [ActionType.LoadCurrentStatusError]:    true,
};


/**
 * Reducer that tracks the user's activity for the logout timer
 */
export const appActivityReducer = (state: AppState, action: Action<ActionType>): AppState => {
  if (ACTIONS_TO_IGNORE[action.type]) {
    return state;
  }

  return R.assoc('lastActivity', new Date(), state);
};
